import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useUserAuth } from "../../context/UserAuthContext";

const ProductComponent = () => {
    const [netErro, setNetErro] = useState(false);
    const { user, userDataLocal, setPurchaseURLCreated, setDowngradeToFreeUser } = useUserAuth();
    const [popupBlocked, setPopupBlocked] = useState(false);
    const handlePurchaseAction = async (priceAction, purchaseID) => {
        let url = '/api/purchase';
        if (priceAction === 'downToFree') {
            url = '/api/downToFree';
            handleDownToFreeAction(purchaseID, url);
        } else if (priceAction === 'purchase') {
            url = '/api/purchase';
            handleAction(purchaseID, url);
        } else if (priceAction === 'renewPayment') {
            url = '/api/renewPayment';
            handleRenewPayment(purchaseID, url);
        }
    }

    const handleRenewPayment = async (purchaseID, url) => {
        const subscriptionId = purchaseID;
        try {
            // Send request to your backend to cancel the subscription
            const response = await axios.post(url, { subscriptionId });
            const renewUrl = response.data.renewPaymentUrl;
            handleOpenUrl(renewUrl);
            
            // Handle success
            // console.log('Your subscription has been canceled. It will remain active until the end of the current billing period.');
            console.log('Response:', response);

          } catch (error) {

            let purchaseHistoryArray = userDataLocal?.Purchasehistory || null;
            let renewPaymentUrl = null;
            if(!purchaseHistoryArray) {
                console.error('No purchase history and Error during renew payment:', error);
                setNetErro(true);
                setTimeout(() => {
                    setPurchaseURLCreated(false);
                }, 10);
            } else {
                let newestPurchasedHistory = purchaseHistoryArray.slice(-1)[0]; //use the newest purchase history
                renewPaymentUrl = newestPurchasedHistory.SubscriptionDetailBody.data.attributes.urls.update_payment_method;
                if (renewPaymentUrl) {
                    handleOpenUrl(renewPaymentUrl);
                } else {
                    console.error('Error during renew payment:', error);
                    setNetErro(true);
                    setTimeout(() => {
                        setPurchaseURLCreated(false);
                    }, 10);
                }
            }
          } 
    }

    const handleOpenUrl = (renewUrl) => {
        const newWindow = window.open(renewUrl, '_blank');
        if (newWindow === null) {
            setPopupBlocked(true);
            console.error('Error during purchase:', ' Popup blocked');
            setTimeout(() => {
                setPurchaseURLCreated(false);
            }, 10);
        } else {
            setPopupBlocked(false);
            // 如果需要，可以在此处处理弹窗成功打开的逻辑
            setNetErro(false);
            setPurchaseURLCreated(true);
        }
    }

    const handleDownToFreeAction = async (purchaseID, url) => {
        const subscriptionId = purchaseID;
        try {
            // Send request to your backend to cancel the subscription
            const response = await axios.post(url, { subscriptionId });
            
            // Handle success
            // console.log('Your subscription has been canceled. It will remain active until the end of the current billing period.');
            console.log('Response:', response);

            setNetErro(false);
            setDowngradeToFreeUser(true);
              
          } catch (error) {
            // Handle error
            // setError('An error occurred while trying to cancel your subscription. Please try again.');
            setNetErro(true);
            setTimeout(() => {
                setDowngradeToFreeUser(false);
            }, 10);
            console.error('Error canceling subscription:', error);
          } 
    }

    const handleAction = async (purchaseID, url) => {
        // console.log('purchaseID:', purchaseID);
        const variantID = purchaseID.toString();
        // console.log('variantID:', variantID);
        try {
            const response = await axios.post(url,{
                "data": {
                    "type": "checkouts",
                    "attributes": {
                    "checkout_data": {
                        "email": userDataLocal.Email,  
                        "name": userDataLocal.Name,
                        "custom": {
                        "user_id": user.uid
                        }
                    }
                    },
                    "relationships": {
                    "store": {
                        "data": {
                        "type": "stores",
                        "id": process.env.REACT_APP_LEMON_SQUEEZY_STORE_ID
                        }
                    },
                    "variant": {
                        "data": {
                        "type": "variants",
                        "id": variantID
                        }
                    }
                    }
                }
                });
            console.log('Response:', response);
            const newWindow = window.open(response.data.data.attributes.url, '_blank');
            if (newWindow === null) {
                setPopupBlocked(true);
                console.error('Error during purchase:', ' Popup blocked');
                setTimeout(() => {
                    setPurchaseURLCreated(false);
                }, 10);
              } else {
                setPopupBlocked(false);
                // 如果需要，可以在此处处理弹窗成功打开的逻辑
                setNetErro(false);
                setPurchaseURLCreated(true);
              }
            

            // window.location.href = response.data.attributes.url;
        } catch (error) {
            console.error('Error during purchase:', error);
            setNetErro(true);
            setTimeout(() => {
                setPurchaseURLCreated(false);
            }, 10);
        }
    };

    return {
        handlePurchaseAction, netErro, setNetErro, popupBlocked, setPopupBlocked
    };
};
export default ProductComponent;